// =======================
// TRIBUNALE FILTER - Search and select
// =======================
document.addEventListener('DOMContentLoaded', function () {
    const tribunaleFilter = document.getElementById('tribunaleFilter');

    if (!tribunaleFilter) return;

    const toggle = tribunaleFilter.querySelector('.dropdown-toggle');
    const searchInput = document.getElementById('tribunaleSearchInput');
    const items = tribunaleFilter.querySelectorAll('.tribunale-item');
    const dropdownMenu = tribunaleFilter.querySelector('.dropdown-menu');

    let selectedValue = null;

    // Reset search when dropdown opens
    tribunaleFilter.addEventListener('show.bs.dropdown', function () {
        searchInput.value = '';
        filterItems('');
    });

    // Focus search input when dropdown opens
    tribunaleFilter.addEventListener('shown.bs.dropdown', function () {
        searchInput.focus();
    });

    // Search filter
    if (searchInput) {
        searchInput.addEventListener('input', function () {
            const searchTerm = this.value.toLowerCase();
            filterItems(searchTerm);
        });
    }

    function filterItems(searchTerm) {
        let visibleCount = 0;

        items.forEach(function (item) {
            const text = item.textContent.toLowerCase();
            if (text.includes(searchTerm)) {
                item.style.display = '';
                visibleCount++;
            } else {
                item.style.display = 'none';
            }
        });

        // Show "no results" message if needed
        // Could add a div for this in the future
    }

    // Handle item selection
    items.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            // Remove active class from all items
            items.forEach(function (i) {
                i.classList.remove('active');
            });

            // Add active class to selected item
            this.classList.add('active');

            // Update toggle text
            selectedValue = this.dataset.value;
            updateToggleText(selectedValue);

            // Close dropdown
            if (dropdownMenu) {
                dropdownMenu.classList.remove('show');
            }
            if (toggle) {
                toggle.classList.remove('show');
                toggle.setAttribute('aria-expanded', 'false');

                const arrow = toggle.querySelector('.arrow');
                if (arrow) {
                    arrow.classList.remove('active');
                }
            }
        });
    });

    function updateToggleText(text) {
        if (toggle) {
            // Remove the arrow temporarily if it exists
            const arrow = toggle.querySelector('.arrow');
            if (arrow) {
                arrow.remove();
            }

            // Update text
            toggle.textContent = text || 'Tribunale';

            // Add or remove 'selected' class based on whether a selection is active
            if (text && text !== 'Tribunale') {
                toggle.classList.add('selected');
            } else {
                toggle.classList.remove('selected');
            }

            // Re-add the arrow
            toggle.insertAdjacentHTML('beforeend', "<div class='arrow arrow--smallest arrow--down arrow--white ms-1'><span></span><span></span></div>");
        }
    }
});
